import { Typography } from '@/components/ui/Text';
import { assetUrl } from '@/lib/directus/assetUrl';
import Image from 'next/image';
import { TBlogArticle } from '../../blog/blog.types';

import { formatBlogDate } from '../../blog/blog.utils';
import './BlogArticlePageOwnership.scss';

type Props = {
  article: TBlogArticle;
  mobile?: boolean;
};

export const BlogArticlePageOwnership: React.FC<Props> = ({
  article: {
    author,
    medicalReviewBy,
    dateUpdated: _dateUpdated,
    datePublished: _datePublished,
  },
  mobile = false,
}) => {
  const dateUpdated = (() => {
    if (!_dateUpdated) return;

    return formatBlogDate(_dateUpdated);
  })();

  const datePublished = (() => {
    if (!_datePublished) return;

    return formatBlogDate(_datePublished);
  })();

  return (
    <>
      {!mobile && (
        <div className='BlogArticlePageOwnership__desktop'>
          <div className='BlogArticlePageOwnership__person-line'>
            <Typography variant='body'>Author:</Typography>

            <div className='BlogArticlePageOwnership__photo-wrapper'>
              <Image
                className='BlogArticlePageOwnership__photo'
                src={assetUrl(author.photo) || ''}
                fill
                alt='author'
              />
            </div>

            <Typography variant='body'>
              {author.firstName} {author.lastName}
            </Typography>
          </div>

          {medicalReviewBy && (
            <div className='BlogArticlePageOwnership__person-line'>
              <Typography variant='body'>Medical review by:</Typography>

              <div className='BlogArticlePageOwnership__photo-wrapper'>
                <Image
                  className='BlogArticlePageOwnership__photo'
                  src={assetUrl(medicalReviewBy.image) || ''}
                  fill
                  alt='author'
                />
              </div>

              <Typography variant='body'>{medicalReviewBy.name}</Typography>
            </div>
          )}

          {datePublished && (
            <Typography variant='body'>{`Published: ${datePublished}`}</Typography>
          )}

          {dateUpdated && (
            <Typography variant='body'>{`Updated: ${dateUpdated}`}</Typography>
          )}
        </div>
      )}

      {mobile && (
        <div className='BlogArticlePageOwnership--mobile'>
          <Typography variant='body'>Author:</Typography>

          <div className='BlogArticlePageOwnership__person-info'>
            <div className='BlogArticlePageOwnership__photo-wrapper--mobile'>
              <Image
                className='BlogArticlePageOwnership__photo'
                src={assetUrl(author.photo) || ''}
                fill
                alt='author'
              />
            </div>

            <Typography variant='body'>
              {author.firstName} {author.lastName}
            </Typography>
          </div>

          {medicalReviewBy && (
            <>
              <Typography variant='body'>Medical review by:</Typography>

              <div className='BlogArticlePageOwnership__person-info'>
                <div className='BlogArticlePageOwnership__photo-wrapper--mobile'>
                  <Image
                    className='BlogArticlePageOwnership__photo'
                    src={assetUrl(medicalReviewBy.image) || ''}
                    fill
                    alt='author'
                  />
                </div>

                <Typography variant='body'>{medicalReviewBy.name}</Typography>
              </div>
            </>
          )}

          {datePublished && (
            <>
              <Typography variant='body'>Published:</Typography>

              <Typography variant='body'>{datePublished}</Typography>
            </>
          )}

          {dateUpdated && (
            <>
              <Typography variant='body'>Updated:</Typography>

              <Typography variant='body'>{dateUpdated}</Typography>
            </>
          )}
        </div>
      )}

      <hr className='BlogArticlePageOwnership__divider' />
    </>
  );
};
